/**
 * Current-user API — read profile + pin/clear the active project.
 */
import { request } from "./client";
import type {
  ActiveProjectRequest,
  UserMeResponse,
} from "../lib/types";

export async function fetchMe(signal?: AbortSignal): Promise<UserMeResponse> {
  return request<UserMeResponse>("/api/v1/users/me", {
    method: "GET",
    signal,
  });
}

export async function setActiveProject(
  projectId: string | null,
): Promise<UserMeResponse> {
  const body: ActiveProjectRequest = { project_id: projectId };
  return request<UserMeResponse>("/api/v1/users/me/active-project", {
    method: "POST",
    body,
  });
}
